import PropTypes from 'prop-types'
import React from 'react'
import { UserAvatar } from 'components/UserAvatar'
import { View } from 'components/View'
import Button from 'components/Button'

function HeaderAvatar ({ value, onClick }) {
  return (
    <Button
      onClick={onClick}
      name='profile'
    >
      <View
        style={{
          justifyContent: View.JUSTIFY.CENTER,
          alignItems: View.ALIGN.CENTER,
          width: '2.22em',
          height: '2.22em',
          color: '#666666',
          transition: 'color 0.125s ease-out'
        }}
      >
        <UserAvatar
          value={value}
          shouldLazyLoad={false}
        />
      </View>
    </Button>
  )
}

HeaderAvatar.defaultProps = {
  value: null
}

HeaderAvatar.propTypes = {
  value: PropTypes.string,
  onClick: PropTypes.func.isRequired
}

export default HeaderAvatar
